<template>
  <div class="detail-item" v-if="editingData && options">
    <div class="head"><b>所属</b></div>
    <div class="data">
      <p>{{ getOptionsLabel(options.syozoku, editingData.syozoku_id) }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
  },
  setup() {
    const { getOptionsLabel } = useKoyouKeiyakuInit()

    return {
      getOptionsLabel
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
